import React, { useState, useRef, useEffect } from 'react';
import { MdOutlineDateRange } from 'react-icons/md';
import './CustomDropdown.css'; // Import your CSS file for styling
import { Box, List, ListItem, Text } from '@chakra-ui/react';
import DatePicker from 'react-datepicker';
import { Button } from 'react-bootstrap';
import { useToasts } from 'react-toast-notifications';

const CustomDropdown = ({ years, selectedYear, setSelectedYear,handleApply,dateRenge }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const dropdownRef = useRef(null); 
  const { addToast } = useToasts();

  const handleInputClick = () => {
    setIsOpen((prev) => !prev);
  };

  const handleOptionClick = (year) => {
    if (year === 'custom') {
      setSelectedYear(year);
    } else {
      setSelectedYear(year);
      setIsOpen(false);
      handleApply({
        startDate:"",
        endDate:""
      })
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [dropdownRef]);


  useEffect(()=>{
    if(dateRenge?.startDate){
      setStartDate(dateRenge?.startDate)
    }
    if(dateRenge?.endDate){
      setEndDate(dateRenge?.endDate)
    }
  },[dateRenge])

  const handleClickApply = (e)=>{
    if (!startDate || !endDate) {
      addToast(`Both start date and end date are required.`, { appearance: "error" });
      return;
    }

    if (startDate > endDate) {
      addToast(`Start date must be less than end date.`, { appearance: "error" });
      return;
    }
    handleApply({
      startDate,
      endDate
    })
    setIsOpen(false)
    
  }
  return (
    <div className="" ref={dropdownRef}>
      <div className="input-container" onClick={()=>handleInputClick()}>
        <Box display="flex" justifyContent="flex-start" >

        <MdOutlineDateRange className="date-icon" />
        <Text>{selectedYear === 'custom' ? 'custom' : selectedYear}</Text>
        </Box>
      </div>
    {isOpen &&
     <Box className='custom-dropdown-box'>
        <List className='dropdown-list'>
            {years.map((item)=>{
                return(
                    <ListItem onClick={()=>{handleOptionClick(item.value)}} className={`listItem ${item?.value === selectedYear ? 'active-item' : ""}`}>{item?.label}</ListItem>
                )
            })}
        </List>
        {selectedYear === 'custom' && (
        <>
        <Box className='ledger-date-renge'>

            <Box mt={2}>
              <Text>Select Date Range:</Text>
              <Box display="flex" justifyContent="space-between">
                <DatePicker
                  selected={startDate}
                  onChange={(date) => setStartDate(date)}
                  selectsStart
                  startDate={startDate}
                  placeholderText="Start Date"
                  className="date-picker"
                  isClearable
                />
                <DatePicker
                  selected={endDate}
                  onChange={(date) => setEndDate(date)}
                  selectsEnd
                  endDate={endDate}
                  placeholderText="End Date"
                  className="date-picker"
                  isClearable
                />
              </Box>
            </Box>
        </Box>
            <Box className='renge-button'>
              <Button className='btn apply' onClick={(e)=>handleClickApply(e)}>Apply</Button>
              <Button className='btn cancel' onClick={()=>setIsOpen(false)}>Cancel</Button>
            </Box>
        </>
          )}
    </Box>
    }
    </div>
  );
};

export default CustomDropdown;